module.exports = "/images/refund_policy_hero.svg?3a426b60d8b5bd32b553af28281aa137";